import { Skeleton, Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import useDetalhesPergunta from "core/features/assembleia/hooks/useDetalhesPergunta";
import { VotacaoPerguntaDto } from "core/features/assembleia/typings";
import colors from "core/resources/theme/colors";
import { Empty } from "antd";
import ResultadoPergunta from "./../ResultadoPergunta/index";
import CardDefault from "ui/components/Cards/CardDefault";
import ResultadoPerguntaParticipantesPeso from "./components/ResultadoPerguntaParticipantesPeso";

function ChartResultadoPergunta({
  votacaoId,
  pergunta,
}: {
  votacaoId: string;
  pergunta: VotacaoPerguntaDto;
}) {
  const { data, isLoading, isFetching } = useDetalhesPergunta(
    votacaoId,
    pergunta.id
  );
  const _isLoading = isLoading || isFetching;

  return (
    <>
      <Flex>
        <ResultadoPerguntaParticipantesPeso
          data={data}
          isLoading={_isLoading}
        />

        <ResultadoPergunta
          isLoading={_isLoading}
          totalVotos={data?.total}
          totalNaoVotaram={data?.totalNaoVotaram}
          perguntaId={pergunta.id}
          totalParticipantes={data?.participantes}
          votacaoId={votacaoId}
        />
      </Flex>
      <CardDefault minH="300px">
        <Flex flexDir="column" gridGap={2} pb={4}>
          <Flex flexDir="row">
            <Flex flex={1}>
              <Text fontSize={20} fontWeight="medium">
                {pergunta.ordem + 1}. {pergunta.titulo}
              </Text>
            </Flex>
          </Flex>

          {!_isLoading ? (
            <Flex as="p" fontSize={12} fontWeight="medium">
              Total de unidades que votaram: {data?.total}
            </Flex>
          ) : null}

          {!_isLoading ? (
            <Flex as="p" fontSize={12} fontWeight="medium">
              Total de votos com peso:{" "}
              {data?.opcoes?.reduce((acc, opcao) => acc + opcao.votos, 0)}
            </Flex>
          ) : null}

          {_isLoading ? (
            <>
              <Skeleton h="50px" rounded={6} w="100%" />
              <Skeleton h="50px" rounded={6} w="100%" />
              <Skeleton h="50px" rounded={6} w="100%" />
              <Skeleton h="50px" rounded={6} w="100%" />
            </>
          ) : data?.opcoes?.length ? (
            data?.opcoes.map((opcao, index) => (
              <ResultBar
                color={
                  // generatedColors[index]
                  //   ? generatedColors[index].hex()
                  //   : colors.gray
                  colors.black50
                }
                label={opcao.titulo}
                total={data.total}
                votos={opcao.votos}
              />
            ))
          ) : (
            <Empty description="Não há opções cadastradas nessa pergunta" />
          )}
        </Flex>
      </CardDefault>
    </>
  );
}
function ResultBar({
  total,
  votos,
  label,
  color,
}: {
  total: number;
  votos: number;
  label: string;
  color: string;
}) {
  return (
    <>
      <Flex justifyContent="space-between" mt={3}>
        <Text fontWeight="semibold" fontSize={16} rounded={6}>
          {label}
        </Text>
      </Flex>

      <Flex
        rounded={6}
        position="relative"
        justifyContent="flex-start"
        alignItems="center"
        borderWidth={2}
        borderColor={colors.black50}
        px={4}
        h="50px"
        bg={`linear-gradient(to right, ${color} 0 ${
          (votos / total) * 100
        }%, white ${(votos / total) * 100}% 100%)`}
      >
        <Text fontSize={14} rounded={6} p={2}>
          {votos} {votos === 1 ? "Voto" : "votos"}
        </Text>
      </Flex>
    </>
  );
}

export default ChartResultadoPergunta;
